@use '@/styles/tokens' as *;

.body {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: var(--space-4);
}

.tabLabel {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  font-size: 11px;
  font-weight: var(--font-weight-medium);
  color: #fff;
  background: var(--status-danger, #ff4136);
  border-radius: 999px;
}

.list {
  flex: 1;
  overflow-y: auto;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-5);
}

.footer {
  position: sticky;
  bottom: 0;
  display: flex;
  padding-top: var(--space-3);

  button {
    width: 100%;
  }
}
